import { render } from "./Wishlist.vue?vue&type=template&id=580f2ed6&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import "./Wishlist.vue?vue&type=style&index=0&id=580f2ed6&scoped=true&lang=css"
import "./Wishlist.vue?vue&type=style&index=1&id=580f2ed6&lang=css"
import "./Wishlist.vue?vue&type=style&index=2&id=580f2ed6&scoped=scoped&lang=css"
import "./Wishlist.vue?vue&type=style&index=3&id=580f2ed6&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f2ed6"]])

export default __exports__